/* localStorage that never throws: private windows, blocked storage and full quotas all read as empty. */
const PREFIX = 'pinnr:'

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (raw == null) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function save(key: string, value: unknown): void {
  try {
    if (value === undefined) localStorage.removeItem(PREFIX + key)
    else localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    /* storage unavailable */
  }
}

export function drop(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key)
  } catch {
    /* storage unavailable */
  }
}

export const session = {
  load<T>(key: string, fallback: T): T {
    try {
      const raw = sessionStorage.getItem(PREFIX + key)
      return raw == null ? fallback : (JSON.parse(raw) as T)
    } catch {
      return fallback
    }
  },
  save(key: string, value: unknown) {
    try {
      if (value === undefined) sessionStorage.removeItem(PREFIX + key)
      else sessionStorage.setItem(PREFIX + key, JSON.stringify(value))
    } catch {
      /* storage unavailable */
    }
  },
  drop(key: string) {
    try {
      sessionStorage.removeItem(PREFIX + key)
    } catch {
      /* storage unavailable */
    }
  },
}
